/// <reference path="./types/window.d.ts" />

export {
  INITIAL_CONTEXT_COOKIE_NAME,
  VISIT_LIST_KEY,
  VISIT_LIST_SWR_CONFIG,
  TRIAGE_CASE_STATUS_KEY,
  TRIAGE_LAST_MESSAGE_KEY,
  TRIAGE_SWR_CONFIG,
  EXTERNAL_ACCOUNT_ID_COOKIE_NAME,
} from "./constants";

export {
  getExternalAccountId,
  resolveExternalAccountId,
  setExternalAccountIdCookie,
} from "./external-account-id";

export { useInitialContext } from "./provider/hooks";

export {
  InitialContext,
  InitialContextProvider,
} from "./provider/initial-context-provider";

export type {
  DefaultApp,
  DefaultCustomData,
  DefaultPatient,
  DefaultAccount,
  DefaultComponent,
  DefaultInitialContext,
  RelationshipToAccountHolder,
} from "./types";

export { RELATIONSHIP_TO_ACCOUNT_HOLDER } from "./types";

export { getInitialContextFromCookie } from "./utils";
